import ViewportDetect from '@djforth/viewport-detection-fp';
import GetBounds from './get_bounds';

import positionStickyDetect from './position_sticky_detect';

const createPlaceholder = ({ width, height }) => {
  const placeholder = document.createElement('div');
  placeholder.classList.add('sticky-placeholder');
  placeholder.style.width = `${width}px`;
  placeholder.style.height = `${height}px`;

  return placeholder;
};

const changeSticky = ({ top }) => {
  let isAdded = false;

  return {
    adding: () => {
      if (window.scrollY >= top && !isAdded) {
        isAdded = true;
        return true;
      }
      return false;
    },
    removing: () => {
      if (window.scrollY < top && isAdded) {
        isAdded = false;
        return true;
      }
      return false;
    },
  };
};

const eventHandler = (stickyPosition, el) => {
  const placeholder = createPlaceholder(stickyPosition);

  const checker = changeSticky(stickyPosition);
  return () => {
    if (checker.adding()) {
      el.style.position = 'fixed';
      el.style.top = '0px';

      if (el.parentNode) {
        el.parentNode.insertBefore(placeholder, el);
      }
    } else if (checker.removing()) {
      el.style.position = 'static';
      el.style.top = '';

      if (el.parentNode) {
        el.parentNode.removeChild(placeholder);
      }
    }
  };
};

const stickyAvailable = (el, devices) => device => {
  if (devices.includes(device)) {
    el.style = 'position:sticky;position:-webkit-sticky;position:-ms-sticky;';
    el.style.top = '0';
  } else {
    el.style.position = 'static';
    el.style.top = '';
  }
};

const noSticky = (el, devices, handler) => device => {
  window.removeEventListener('scroll', handler);
  if (devices.includes(device)) {
    window.addEventListener('scroll', handler);
  } else {
    el.style.position = 'static';
    el.style.top = '';
  }
};

export default id => {
  const el = document.getElementById(id);
  if (!el) return null;

  const positionStickySupport = positionStickyDetect();
  const devices = JSON.parse(el.dataset.sticky);

  const stickyPosition = GetBounds(el);
  const vpDetect = ViewportDetect();
  const handler = eventHandler(stickyPosition, el);

  const setSticky = positionStickySupport ? stickyAvailable(el, devices) : noSticky(el, devices, handler);

  setSticky(vpDetect.getDevice());

  vpDetect.addCallback(setSticky);

  vpDetect.track();
};
